import { Box, Container } from "@mui/material";
import SignUpComponent from "../components/signUp/SignUpComponent";

const SignUpPage = () => {
  return (
    <Container sx={{ display: "flex", justifyContent: "center" }}>
      <Box
        sx={{
          maxWidth: "400px",
          border: "2px solid #eee ",
          borderRadius: "10px",
          padding: "25px",
          marginTop: "25px",
        }}
      >
        <SignUpComponent />
      </Box>
    </Container>
  );
};

export default SignUpPage;
